
import { Event } from './event';

export class EventManager {
  private events: {[key: string]: Event};

  public constructor () {
    this.events = {};
  }

  /**
   * Register new Event.
   *
   * @param {Event} event
   */
  public registerEvent(event: Event) {
    this.events[event.code] = event;
  }

  /**
   * Listen for a specific event.
   *
   * @param {string} code
   * @param listener
   * @return {boolean}
   */
  public listen(code: string, listener: any) {
    if (! this.events.hasOwnProperty(code)) {
      return false;
    }

    if (! this.events[code].listeners) {
      this.events[code].listeners = [];
    }
    (this.events[code].listeners as any[]).push(listener);
    return true;
  }

  /**
   * Fire a specific code with optional parameters given to all listeners.
   *
   * @param {string} code
   * @param payload
   * @return {number}
   */
  public fire(code: string, payload: any = {}): number {
    if (! this.events.hasOwnProperty(code)) {
      return 0;
    }

    const event = this.events[code];
    if (! event.listeners) {
      return 0;
    }

    let hits = 0;
    for (const listener of event.listeners) {
      if (listener instanceof Function) {
        listener(payload);
        hits++;
      }
    }
    return hits;
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/core/events/manager.ts